module.exports = __webpack_public_path__ + "img/901615479.087adf3a.png";